<div class="modal-header">
  <h4 class="modal-title">{{ title() }}</h4>
  <ui-button
    [icon]="'cross-square'"
    [iconClass]="'fs-2 text-info'"
    [severity]="'light'"
    [size]="'auto'"
    (click)="activeModal.close()"
  ></ui-button>
</div>
<div class="modal-body">
  <p class="fw-bold m-0">{{ description() }}</p>
</div>
<div *transloco="let t; prefix: 'uiKit'" class="modal-footer">
  <ui-button
    [severity]="'secondary'"
    [buttonText]="t('buttons.cancel')"
    (click)="activeModal.close(false)"
  ></ui-button>
  @if (action() === 'delete') {
    <ui-button
      [severity]="'danger'"
      [buttonText]="t('buttons.delete')"
      (click)="confirm()"
    ></ui-button>
  }
  @if (action() === 'confirm') {
    <ui-button
      [severity]="'success'"
      [buttonText]="t('buttons.confirm')"
      (click)="confirm()"
    ></ui-button>
  }
</div>
